<template>
    <li v-if="show" @click="selectOption()"
        :class="{
            'active-single fw-600': model === value && labelModel !== '',
            'hover-li': index === value,
        }">
        {{label}}
        <i class="icon ion-md-checkmark float-right" v-if="model === value && labelModel !== '' && multiple"></i>
    </li>
</template>
<script>
export default {
    props: ['value', 'label'],
    data() {
        return {
            show: true,
            model: '',
            labelModel: '',
            multiple: false,
            index: '',
        }
    },
    mounted(){
        let parent = this.$parent;
        this.multiple = parent.$props.multiple;
        if(parent && parent.$vnode && parent.$vnode.componentOptions
            && parent.$vnode.componentOptions.tag == 'ldc-select'){
                if(this.value != undefined && this.label != undefined){
                    this.show = true;
                    if(this.checkPush(parent.$data.options)){
                        parent.$data.options.push({
                            value: this.value,
                            label: this.label
                        })
                    }else{
                        console.warn('Component ldc-option có data trùng với 1 Component ldc-option khác, việc này sẽ k hiển thị component ldc-option trùng')
                    }
                }else{
                    console.error('Vui lòng truyền prop value và label khác undefined');
                    this.show = false
                }
            }else{
                console.error('Component ldc-option chỉ hoạt động trong component ldc-select');
                this.show = false;
            }
    },
    methods: {
        checkPush(options){
            let check = true;
            options.map(item => {
                if(item.value === this.value && item.label === this.label){
                    check = false;
                }
            });
            return check;
        },
        selectOption(){
            if(this.multiple){
                if(!this.$parent.$data.data.includes(this.value)){
                    this.$parent.$data.data.push(this.value);
                }else{
                    this.$parent.$data.data.map((item, index) => {
                        if(item === this.value){
                            this.$parent.$data.data.splice(index, 1)
                        }
                    })
                }
                if(!this.$parent.$data.model.includes(this.label)){
                    this.$parent.$data.model.push(this.label);
                }else{
                    this.$parent.$data.model.map((item, index) => {
                        if(item === this.label){
                            this.$parent.$data.model.splice(index, 1)
                        }
                    })
                }
            }else{
                this.$parent.$data.data = this.value;
                this.$parent.$data.model = this.label;
                this.$parent.activeDropdown();
            }
            setTimeout(() => {
                if(this.$parent.$data.change) this.$parent.$data.change();
            }, 0);
        },
    }
}
</script>